var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "aria-current": "location"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.partner_management', '合作夥伴專區')) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.displayText('partner.partner_staff_list', '夥伴帳號列表')))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center justify-content-between mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText('partner.partner_staff_list', '夥伴帳號列表')) + " ")]), _c('div', {
    staticClass: "\n          col-12 col-xl-8\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.PARTNER_STAFF_CREATE]) && _vm.partner_id ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'PartnerStaffCreate',
        params: {
          partnerId: _vm.partner_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.displayText('partner.partner_staff_add', '新增夥伴帳號')))]) : _vm._e(), _vm.partnerDropdownVisible ? _c('b-form-select', {
    staticClass: "mr-3 mb-2 mb-xl-0",
    attrs: {
      "options": _vm.partners,
      "disabled": _vm.isDropdownDisabled
    },
    model: {
      value: _vm.partner_id,
      callback: function callback($$v) {
        _vm.partner_id = $$v;
      },
      expression: "partner_id"
    }
  }) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.displayText('partner.staff_search_placeholder', '請輸入姓名、手機號碼、email、員工編號')
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPartnerStaffs();
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.getPartnerStaffs();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.partnerStaffs,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.PARTNER_STAFF_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'PartnerStaffSetPartner',
              params: {
                staff_id: data.item.id,
                partnerId: _vm.partner_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-home-outline"
        }), _vm._v(" " + _vm._s(_vm.displayText('partner.set_belong_partner_company', '所屬公司')) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_STAFF_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'PartnerStaffView',
              params: {
                staff_id: data.item.id,
                partnerId: _vm.partner_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText('partner.view', '查看')) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_STAFF_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'PartnerStaffEdit',
              params: {
                staff_id: data.item.id,
                partnerId: _vm.partner_id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText('partner.edit', '編輯')) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_STAFF_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteStaff(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v(" " + _vm._s(_vm.displayText('partner.delete', '刪除')) + " ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("目前第 " + _vm._s(_vm.currentPage) + " 頁 / 總共 " + _vm._s(Math.ceil(_vm.totalRows / _vm.query.per_page)) + " 頁")])]), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_vm.totalRows > 0 ? _c('b-pagination', {
    staticClass: "my-auto",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.query.per_page
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-md-auto mb-3"
  }, [_c('span', [_vm._v("每頁顯示數量：")]), _c('b-form-select', {
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "options": _vm.perPageOption
    },
    model: {
      value: _vm.query.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "per_page", $$v);
      },
      expression: "query.per_page"
    }
  }), _c('span', [_vm._v(" / 總數量: " + _vm._s(_vm.totalRows))])], 1)])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }